import { combineReducers } from "@reduxjs/toolkit";
import displayConditions from "./displayConditionsSlice";

const reducer = combineReducers({
  displayConditions,
});

export default reducer;
